import type { ReactNode } from "react";
import styles from "./ListToolbar.module.css";

type ListToolbarProps = {
  ariaLabel: string;
  /** 좌측 — 보통 `FilterResultCount`. */
  summary?: ReactNode;
  /** 우측 — 새로고침 등 목록 도구. */
  actions?: ReactNode;
};

/**
 * 필터 바와 표 사이의 띠. 결과 수와 목록 도구가 이 자리를 갖는다(규칙 §13).
 *
 * 일괄 액션이 생기면 좌측 앞자리가 그 버튼 줄이 된다.
 */
export function ListToolbar({ actions, ariaLabel, summary }: ListToolbarProps) {
  return (
    <div aria-label={ariaLabel} className={styles.toolbar} role="toolbar">
      <div className={styles.summary}>{summary}</div>
      <div className={styles.actions}>{actions}</div>
    </div>
  );
}
